import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import Layout from "../components/Layout";
import Seo from "../components/Seo";

export default function Journal() {
  const [items, setItems] = useState([]);
  useEffect(() => { api("/api/posts").then(setItems).catch(() => {}); }, []);
  return (
    <Layout>
      <Seo title="Sri Lanka Journal" description="Stories from Hambantota, Koggala, Unawatuna, and Kandy by Vishmi Travels." path="/journal" />
      <header className="page-hero">
        <div className="wrap">
          <p className="eyebrow">Explore Sri Lanka</p>
          <h1>Journal</h1>
        </div>
      </header>
      <section className="section">
        <div className="wrap card-grid">
          {items.map((post) => (
            <Link key={post._id} to={`/journal/${post.slug}`} className="story-card" style={{ backgroundImage: `url(${post.coverImage})` }}>
              <div>
                <p className="eyebrow">{post.category}</p>
                <h3>{post.title}</h3>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </Layout>
  );
}
